import { Box } from '@mui/material';
import { useState } from 'react';

import { PageTabs } from '@/components';
import { appStyles } from '@/theme';

import { OrgPlaylistCreator, PinnedLpsCurator } from './components';

const TABS = [
  { value: 'Recommended Episodes', label: 'Recommended Episodes' },
  { value: 'Learning Paths', label: 'Learning Paths' },
];

export const AdminContent = () => {
  const [selectedTab, setSelectedTab] = useState(TABS[0].value);

  return (
    <Box
      sx={[
        appStyles.limitPageWidth,
        { display: 'flex', flexDirection: 'column', gap: 4, width: '100%' },
      ]}>
      <PageTabs
        tabs={TABS}
        selectedTab={selectedTab}
        onChange={(e, newVal) => setSelectedTab(newVal)}
      />
      <Box sx={{ display: selectedTab === TABS[0].value ? 'block' : 'none' }}>
        <OrgPlaylistCreator />
      </Box>
      <Box sx={{ display: selectedTab === TABS[1].value ? 'block' : 'none' }}>
        <PinnedLpsCurator />
      </Box>
    </Box>
  );
};
